import { apiRequest } from "./apiClient";
export const getAllProviders = async () => {
  const response = await apiRequest({ method: "GET", endpoint: "/insurance-providers" });
  return response.data.map((provider) => ({
    value: provider.id,
    label: provider.name,
  }));
};

